// add react FC to toggle localStorage.disableImplicit

import { FC } from 'react'
import { t } from 'ttag'

import { Switch } from '../utils/Switch'
import { useLocalStorage } from '../utils/Hooks'
import './ToggleDisableBackgroundDownloads.css'


export const ToggleDisableBackgroundDownloads: FC = () => {
    const [disableImplicit, setDisableImplicit] = useLocalStorage('disableImplicit', false)
    const enableBackgroundDownloads = !disableImplicit

    const ENABLED = t`ENABLED`
    const DISABLED = t`DISABLED`
    const labelBackgroundDownloads = t`Background downloads`

    const handleToggle = () => {
        const newEnabled = !enableBackgroundDownloads
        console.log(`user toggled background downloads to ${newEnabled ? ENABLED : DISABLED}`)
        setDisableImplicit(!newEnabled)
    }

    const tooltip = disableImplicit ? 
        t`Disabled: stops SLTT downloading all the videos it predicts you might want to watch next` :
        t`Enabled: allows SLTT downloading all the videos it predicts you might want to watch next`

    return (
        <div className="toggle-disable-background-downloads-container" title={tooltip}>
            <div className="toggle-disable-background-downloads-icon"><span className="fa-solid fa-download"></span></div>
            <div>{labelBackgroundDownloads}:</div>
            <div className="toggle-disable-background-downloads-switch">
                <label>
                    <div>
                        <Switch
                            className=""
                            value={enableBackgroundDownloads}
                            setValue={handleToggle}
                            enabled={true}
                            tooltip={tooltip}>
                        </Switch>
                    </div>
                </label>
            </div>
            <div>
                <span>{enableBackgroundDownloads ? ENABLED : DISABLED}</span>
            </div>
        </div>
    )
}
